<template>
  <div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="暂无更多优惠券"
      @load="getCouponList"
    >
      <van-row class="couponListBody">
        <van-col :span="24" class="bg-white coupon m-t-06" v-for="(item,index) in list" :key="index" @click="goDetial(item)">
          <van-row>
            <van-col :span="5" class="colorOrigin text-c">
              <span class="f-s-6 ">¥</span>
              <span class="f-s-13" style="font-weight: 500;">{{item.amount}}</span>
              <p class="f-s-6 text-c">优惠券</p>
            </van-col>
            <van-col :span="11" :offset="1">
              <div class="van-ellipsis f-s-7" style="line-height:2rem">{{item.name}}</div>
              <van-count-down :time="item.timestamp" class="f-s-7">
                <template #default="timeData">
                  <span class="colorOrigin">倒计时:</span>
                  <span class="block">{{ timeData.days }}</span>
                  <span class="colon" style="">天</span>
                  <span class="block">{{ timeData.hours }}</span>
                  <span class="colon">:</span>
                  <span class="block">{{ timeData.minutes	 }}</span>
                </template>
              </van-count-down>
            </van-col>
            <van-col :span="6" class="text-c" :offset="1">
              <van-button class="xz-button-info f-s-6 useBtn m-t-9">立即使用</van-button>
            </van-col>
          </van-row>
          
        </van-col>
      </van-row>
    </van-list>
  </div>
</template>

<script>
export default {
  props:{
    list:{
      type:Array,
      default:() => {
        return []
      }
    }
  },
  data(){ 
    return {
      time:1548165849785,
      loading:false,
      finished:false
    }
  },
  methods:{
    getCouponList(){
      this.$emit('getCouponList')
    },
    goDetial(parme){
      this.$router.push({
        path: "/details",
        query: {
          cid: parme.cid,
        },
      });
    }
  }
}
</script>

<style lang="less" scoped>
// 优惠卷列表最大盒子样式
.couponListBody {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.useBtn {
  border-radius: 0.8rem;
  height: 1.3rem;
}
.coupon {
  padding: 1rem 0.3rem 0.75rem 0.75rem;
}
 .colon {
    display: inline-block;
    margin: 0 4px;
    color: black;
  }
  .block {
    display: inline-block;
    width: 22px;
    color: #fff;
    font-size: 12px;
    text-align: center;
    background-color: #FE7B11;
  }
</style>